/* eslint-disable react/jsx-no-undef */
import React from "react";

// import { useNavigate } from "react-router-dom";

import { useNavigate, useLocation } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import TransparentButton from "../../components/button/TransparentButton";
import SecondaryButton from "../../components/button/SecondaryButton";
import bingobg from '../../assets/images/bingobg.png'
import bingoBanner from '../../assets/images/bingo-banner.png'
import bingoFail from '../../assets/images/bingo-fail.png'
import bingoWin from '../../assets/images/bingo-win.png'
import gift from '../../assets/images/icon/gift.svg'
import { SearchPrizeBingo } from "../../services/Bingo";
import { useSelector } from 'react-redux';
import ErrorPopup from "../../components/popup/ErrorPopup";
// import bg from "../../assets/images/test_bg.png";
import sucess from "../../assets/images/gift.png";
import fail from "../../assets/images/box.png";
import useWindowDimensions from "../../functions/getScreen";


export default function BingoResult() {
  const { state } = useLocation();
  const isSuccess = state.isSuccess
  const isRecieve = state.isRecieve
  // const isSuccess = true
  // const isRecieve = false
  const navigate = useNavigate();
  const store = useSelector((state) => state.luckyDraw)
  const [prizeId, setPrizeId] = React.useState(null);
  const bg = store['bgPicture']
  const banner = store['logoPicture']
  const { width } = useWindowDimensions();

  const [openErrorPopup, setOpenErrorPopup] = React.useState(false);


  async function getSearchPrizeBingo() {
    let payload = {
      memberId: store['memberId'],
      bingoId: store['campaignId'],
      limit: 10,
      offset: 0,
    }
    return await SearchPrizeBingo({
      data: payload
    })
      .then(async (response) => {
        if (+response.data.resultCode === 20000) {
          setPrizeId(response.data.body.rewards[0].prizeId)
        } else {
          setOpenErrorPopup(true)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  React.useEffect(() => {
    if (isSuccess && !isRecieve) {
      getSearchPrizeBingo()
    }
  }, []);


  return (
    <>

      <ErrorPopup
        open={openErrorPopup}
        actionFunction={() => {
          setOpenErrorPopup(false)
        }}
      />
      <TopLogo />
      {/* <div
        style={{
          background: `url(${bg}) no-repeat center center fixed`,
          minHeight: "calc(100vh - 60px)",
          padding: "25px",
          backgroundSize: "cover",
          position: "relative"
        }}
      >
        <img
          className="mx-auto mt-[40px]"
          src={bingoBanner}
          alt="logo"
          style={{ width: "233px" }}
        />

        {isSuccess ? (
          <img
            className="mx-auto mt-[30px]"
            src={bingoWin}
            alt="logo"
            style={{ width: "173px" }}
          />) : (
          <img
            className="mx-auto mt-[60px]"
            src={bingoFail}
            alt="logo"
            style={{ width: "171.5px" }}
          />)
        }


        < div className="text-center" style={{
          position: "fixed",
          transform: "translate(-50%, -50%)",
          bottom: "120px",
          left: "50%",
        }}>
          {isSuccess ? (
            <div>
              <p className="text-white font-bold text-[34px] leading-[20px]">ยินดีด้วย!</p>
              <p className="text-white font-bold text-[24px]">คุณถูกรางวัลบิงโก</p>
            </div>
          ) : (
            <div>
              <p className="text-white font-bold text-[34px] leading-[20px]">เสียใจด้วย!</p>
              <p className="text-white font-bold text-[24px]">คุณไม่ถูกรางวัลบิงโก</p>
            </div>
          )}

        </div>


        <div className="text-center mt-[30px]">
          {(isSuccess && !isRecieve) ? (
            <SecondaryButton variant="contained"
              className="w-[70%]"
              style={{
                position: "fixed",
                transform: "translate(-50%, -50%)",
                bottom: "50px",
                left: "50%",
              }}
              onClick={() => {
                if (prizeId) {
                  navigate("/prize-detail",
                    {
                      state: prizeId
                    })
                } else {
                  alert('data not found')
                }
              }}>
              <img className="w-[14px]" src={gift} alt="" />
              <p>รับรางวัล</p>
            </SecondaryButton>

          ) : (isSuccess && isRecieve) ? (
            <SecondaryButton variant="contained"
              className="w-[70%]"
              style={{
                position: "fixed",
                transform: "translate(-50%, -50%)",
                bottom: "50px",
                left: "50%",
              }}
              onClick={() => {
                navigate('/prize', {
                  state: { isHistory: true }
                })
              }}>
              <img className="w-[14px]" src={gift} alt="" />
              <p>รับรางวัลแล้ว</p>
            </SecondaryButton>

          ) : (
            <TransparentButton variant="contained"
              className="w-[70%]"
              style={{
                position: "fixed",
                transform: "translate(-50%, -50%)",
                bottom: "50px",
                left: "50%",
              }}
              onClick={() => {
                navigate('/event')
              }}>
              กลับหน้า Bingo
            </TransparentButton>
          )}
        </div>
      </div > */}
      <div
        style={{
          background: `url(${bg}) no-repeat center center fixed`,
          minHeight: "calc(100vh - 60px)",
          padding: "20px",
          backgroundSize: "cover",
          position: "relative"
        }}
      >
        <img
          className="mt-[-25px] ml-[-25px]"
          src={banner}
          alt="logo"
          style={{ width: width, maxWidth: 'none' }}
        />

        {isSuccess ? (
          <>
            <div className="mx-auto w-fit text-center mt-[30px]">
              <p className="text-white font-bold text-[45px] leading-[40px]">ยินดีด้วย</p>
              <p className="text-white text-[38px] leading-[38px]">คุณได้รับรางวัล</p>
            </div>
            <img
              className="mx-auto w-[300px]"
              src={sucess}
              alt="logo"
            />
          </>) : (
          <>
            <div className="mx-auto w-fit text-center mt-[30px]">
              <p className="text-white font-bold text-[45px] leading-[40px]">คุณไม่ได้รับรางวัล</p>
              <p className="text-white text-[24px]">ไว้ร่วมสนุกกันใหม่ในครั้งหน้า เร็ว ๆ นี้</p>
            </div>
            <img
              className="mx-auto w-[250px]"
              src={fail}
              alt="logo"
            />
          </>)
        }


        {/* < div className="text-center" style={{
          position: "fixed",
          transform: "translate(-50%, -50%)",
          bottom: "120px",
          left: "50%",
        }}>
          {isSuccess ? (
            <div>
              <p className="text-white font-bold text-[34px] leading-[20px]">ยินดีด้วย!</p>
              <p className="text-white font-bold text-[24px]">คุณถูกรางวัลบิงโก</p>
            </div>
          ) : (
            <div>
              <p className="text-white font-bold text-[34px] leading-[20px]">เสียใจด้วย!</p>
              <p className="text-white font-bold text-[24px]">คุณไม่ถูกรางวัลบิงโก</p>
            </div>
          )}

        </div> */}


        <div className="text-center">
          {(isSuccess && !isRecieve) ? (
            <SecondaryButton variant="contained"
              className="w-[70%]"
              style={{
                position: "fixed",
                transform: "translate(-50%, -50%)",
                bottom: "50px",
                left: "50%",
              }}
              onClick={() => {
                if (prizeId) {
                  navigate("/prize-detail",
                    {
                      state: prizeId
                    })
                } else {
                  alert('data not found')
                }
              }}>
              <img className="w-[14px]" src={gift} alt="" />
              <p>รับรางวัล</p>
            </SecondaryButton>

          ) : (isSuccess && isRecieve) ? (
            <SecondaryButton variant="contained"
              className="w-[70%]"
              style={{
                position: "fixed",
                transform: "translate(-50%, -50%)",
                bottom: "50px",
                left: "50%",
              }}
              onClick={() => {
                navigate('/prize', {
                  state: { isHistory: true }
                })
              }}>
              <img className="w-[14px]" src={gift} alt="" />
              <p>รับรางวัลแล้ว</p>
            </SecondaryButton>

          ) : (
            <TransparentButton variant="contained"
              className="w-[70%]"
              style={{
                position: "fixed",
                transform: "translate(-50%, -50%)",
                bottom: "50px",
                left: "50%",
              }}
              onClick={() => {
                navigate('/event')
              }}>
              กลับหน้า Bingo
            </TransparentButton>
          )}
        </div>
      </div >
    </>
  );
}
